import Member from "./member";
import PropTypes from "prop-types";
import React from "react";
import UnlicensedMember from "./unlicensed-member";
import { sortByCustomDisplayOrder } from "./../../shared/util";
const mapUnlicensedMembers = (entity) => {
  if (
    entity.siteOptions.unlicensedMembers &&
    entity.siteOptions.unlicensedMembers.length > 0
  ) {
    return entity.siteOptions.unlicensedMembers.map((u, i) => (
      <UnlicensedMember
        memberDisplayLogic={entity.memberDisplayLogic}
        member={u}
        key={i}
      />
    ));
  }
  return null;
};

const TeamMembers = ({ entity }) => {
  if (!entity.memberDisplayLogic.hasAnyMembers) return null;

  let teamMembers, unlicensedMembers;
  const classes = ["team-members"];
  if (entity.memberDisplayLogic.hasTeamMembers) {
    teamMembers = sortByCustomDisplayOrder(
      entity.teamMembers,
      entity.siteOptions.teamMemberOptions
    ).map((m) => (
      <Member
        memberDisplayLogic={entity.memberDisplayLogic}
        member={m}
        key={m.agentId}
      />
    ));
  }

  if (entity.memberDisplayLogic.hasUnlicensedMembers) {
    unlicensedMembers = mapUnlicensedMembers(entity);
  }

  if (!entity.memberDisplayLogic.hasPhotos) {
    classes.push("no-team-photos");
  }

  return (
    <div className={classes.join(" ")}>
      <h2 className="wide-header">Team Members</h2>
      <div style={{ height: "100px" }} />
      <div>
        {teamMembers}
        {unlicensedMembers}
      </div>
    </div>
  );
};

TeamMembers.propTypes = {
  entity: PropTypes.object,
};

export default TeamMembers;



// WEBPACK FOOTER //
// ./src/components/about/team/index.js